import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import axios from "axios";
Vue.prototype.$axios = axios;

import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
//import Amplify, * as AmplifyModules from "aws-amplify";
import { Amplify } from "aws-amplify";
import * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsconfig from "./aws-exports";
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

Amplify.configure(awsconfig);
applyPolyfills().then(() => {
  defineCustomElements(window);
});
// Amplify.configure({
//   // OPTIONAL - if your API requires authentication
//   // Auth: {
//   //     // REQUIRED - Amazon Cognito Identity Pool ID
//   //     identityPoolId: 'ap-northeast-1:56eba067-eeda-41db-9b00-ec7d38a1cb68',
//   //     // REQUIRED - Amazon Cognito Region
//   //     region: 'ap-northeast-1',
//   //     // OPTIONAL - Amazon Cognito User Pool ID
//   //     userPoolId: 'ap-northeast-1_ExAE5Z1cB',
//   //     // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
//   //     userPoolWebClientId: '31nmrb2ondcch8gqgn3eb009nq',
//   // },
//   API: {
//     endpoints: [
//       {
//         name: "InasakuAPI",
//         endpoint:
//           "https://amb1hya84a.execute-api.ap-northeast-1.amazonaws.com/test",
//         region: "ap-northeast-1"
//       }
//     ]
//   }
// });

Vue.use(AmplifyPlugin, AmplifyModules);

import Toasted from 'vue-toasted';
Vue.use(Toasted);

// VeeValidationの設定
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, numeric, double, regex, oneOf, max, min_value, max_value, between, email } from 'vee-validate/dist/rules';

// バリデーションルール
// 必須項目
required.message = '必須項目です';
extend('required', required);
// 数値のみ、小数点不可
numeric.message = '数値のみ入力してください';
extend('numeric', numeric);
// 小数点を必ず含む数値のみ
double.message = '小数点を含む数値を入力してください';
extend('double', double);
// 正規表現を指定する
regex.message = '必須項目です';
extend('regex', regex);
// リストから選択
oneOf.message = 'リストから選択してください';
extend('oneOf', oneOf);
// 文字数上限
max.message = '入力可能な文字数を超えています({length}文字)';
extend('max', max);
// 下限値のみのバリデーション / 数値専用 / 小数点以下も判定される / 例)rules="min_value:0"
min_value.message = '下限値({min})を下回っています';
extend('min_value', min_value);
// 上限値のみのバリデーション / 数値専用 / 小数点以下も判定される / 例)rules="max_value:0"
max_value.message = '上限値({max})を上回っています';
extend('max_value', max_value);
// 下限値及び上限値のバリデーション / 数値専用 / 小数点以下も判定される / 例)rules="between:-10,10"
between.message = '範囲外の数値を入力しています({min}～{max})';
extend('between', between);
// Eメールアドレス
email.message = '有効なメールアドレスを入力してください';
extend('email', email);
const customEmail = {
  params: [],
  message: '有効なメールアドレスを入力してください',
  validate(value) {
    // var pattern = /^[a-zA-Z0-9+=.@-]+$/;
    var pattern = /^[!-~]+$/;
    if (email.validate(value)) {
      return value ? value.match(pattern) : true;
    }
  }
};
extend('customEmail', customEmail);
// カスタムルール：数値
const customDouble = {
  params: [],
  message: '整数部分は9桁まで、小数点以下は3桁まで入力できます',
  validate(value) {
    var pattern = /^[-]?([1-9]\d{0,8}|0)(\.\d{1,3})?$/;
    return value ? String(value).match(pattern) : true;
  }
};
extend('customDouble', customDouble);
const customDoubleTwo = {
  params: [],
  message: '整数部分は9桁まで、小数点以下は2桁まで入力できます',
  validate(value) {
    var pattern = /^[-]?([1-9]\d{0,8}|0)(\.\d{1,2})?$/;
    return value ? String(value).match(pattern) : true;
  }
};
extend('customDoubleTwo', customDoubleTwo);
const customDoubleOne = {
  params: [],
  message: '整数部分は9桁まで、小数点以下は1桁まで入力できます',
  validate(value) {
    var pattern = /^[-]?([1-9]\d{0,8}|0)(\.\d{1})?$/;
    return value ? String(value).match(pattern) : true;
  }
};
extend('customDoubleOne', customDoubleOne);
const customDoubleWeather = {
  params: [],
  message: '整数部分は4桁まで、小数点以下は1桁まで入力できます',
  validate(value) {
    var pattern = /^[-]?([1-9]\d{0,3}|0)(\.\d{1})?$/;
    return value ? String(value).match(pattern) : true;
  }
};
extend('customDoubleWeather', customDoubleWeather);
const customDoubleWater = {
  params: [],
  message: '整数部分は2桁まで、小数点以下は1桁まで入力できます',
  validate(value) {
    var pattern = /^[-]?([1-9]\d{0,1}|0)(\.\d{1})?$/;
    return value ? String(value).match(pattern) : true;
  }
};
extend('customDoubleWater', customDoubleWater);
// カスタムルール：連動必須
const linkedRequired = {
  params: [ 'target' ],
  message: '必須項目です',
  validate(value, { target }) {
    return {
      required: true,
      valid: !((['', null, undefined].indexOf(value) !== -1) && (['', null, undefined].indexOf(target) === - 1))
    };
  },
  computesRequired: true
};
extend('linkedRequired', linkedRequired);
// カスタムルール：作業項目管理 - 作業項目登録画面 作業分類名プルダウンの必須チェック
const workItemDetailEditSeasonRequired = {
  params: [],
  message: '必須項目です',
  validate(value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value.season_id) === -1
    };
  },
  computesRequired: true
};
extend('workItemDetailEditSeasonRequired', workItemDetailEditSeasonRequired);
// カスタムルール：パスワード
const complexPassword = {
  params: [],
  message: '8文字以上、アルファベット大文字・小文字・数字をそれぞれ1つ以上含む。',
  validate(value) {
    if (value && value.length >= 8) {
      if (value.match(/[A-Z]{1,}/) && value.match(/[a-z]{1,}/) && value.match(/[0-9]{1,}/)) {
        return true;
      }
    }
    return false;
  }
};
extend('complexPassword', complexPassword);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.config.productionTip = false;

Vue.prototype.$Amplify = Amplify;

// gtag
import VueGtag from "vue-gtag";

const restEndpoint = awsconfig.aws_cloud_logic_custom[0].endpoint;
const envName = restEndpoint.split("amazonaws.com/")[1];
if (envName === "prod") {
  Vue.use(
    VueGtag,
    {
      config: { id: "UA-180154411-1" }
    },
    router
  );
} else {
  console.log(`skipped using gtag. envName: ${envName}`);
}

// Floating Vue
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
Vue.use(FloatingVue);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
